import { FormField } from './form-field';

export class FormFieldTextArea extends FormField<string> {
  controlType = 'textarea';
  type = 'textarea';
  cssClasses = 'row column form-row form-control-wrapper required';

  constructor(options: {} = {}) {
    super(options);
    // this.type = options['type'] || '';
  }
}
